<template>
  <div id="app">
    <Navbar style="position:sticky; top: 0; z-index:10;"/>
    <router-view/>
    <Footer style="z-index:10;"/>
    <backtop />
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from '@/components/top_Navbar.vue';
import Footer from '@/components/top_Footer.vue';
import backtop from '@/components/top_Backtop.vue';

export default {
  name: 'Home',
  components: {
    Navbar,
    Footer,
    backtop,
  },
};
</script>

<style lang="scss">
@import "./assets/all.scss";

// 要改頁面色彩的話，可以參考以下：
// top_Navbar、top_Footer、footer_information、products_card、title_onecolorbg
// only_button、top_Services_sidebar、award_text
$darkOrange:#AE4B34;
$orange:#DD6439;
$lightOrange:#E58861;

$darkBlue:#239FC1;
$blue:#30AFC6;
$lightBlue:#46B3CF;

$moreDarkGreen: #729d49;
$darkGreen:#84B555;
$green:#9DC281;
$lightGreen:#A6CB7E;

$blackBlue:#25485A;
$grayBlue:#2685B3;
$darkGray:#576575;

$pramary-blue: #009FB7;
$pramary-lightblue: #5898B9;


#app {
  width: 100%;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: 'Noto Sans TC', sans-serif, 'Balsamiq Sans', cursive;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
}

</style>
